import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from 'classnames';
import * as React from 'react';
import { getInputSizeStyles, getInputStateClass } from './utils';
import { UXPContext } from '@core/context/Context';
import { FontAwesomeIconWrapper } from '@icon/fontawesome/FontAwesomeIconWrapper';
/**
 *
 * A standard textarea (multi line text box)
 * @export
 */
const TextArea = React.forwardRef((props, ref) => {
    const context = React.useContext(UXPContext);
    const { value, onChange, onBlur, onFocus, onKeyDown, className, rows, cols, readOnly, disabled, style, tabIndex, minWidth, maxWidth, width, fullWidth, isValid, onClear } = props;
    const inputContainerRef = React.useRef(null);
    const inputRef = React.useRef(null);
    React.useImperativeHandle(ref, () => ({
        focus: () => { var _a; return (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.focus(); },
        getElement: () => inputRef.current
    }));
    const handleChange = (e) => {
        if (readOnly || disabled)
            return;
        let value = e.target.value;
        onChange(value);
    };
    function handleFocus(e) {
        var _a;
        if (readOnly || disabled)
            return;
        (_a = inputContainerRef.current) === null || _a === void 0 ? void 0 : _a.classList.add("uxpcore_input--focus");
        if (onFocus)
            onFocus();
    }
    function handleBlur(e) {
        var _a;
        if (readOnly || disabled)
            return;
        (_a = inputContainerRef.current) === null || _a === void 0 ? void 0 : _a.classList.remove("uxpcore_input--focus");
        if (onBlur)
            onBlur(value);
    }
    function handleKeyDown(e) {
        if (readOnly || disabled)
            return;
        if (onKeyDown) {
            onKeyDown(e, value);
        }
    }
    // Calculate size styles and state classes
    const inputSizeStyles = getInputSizeStyles({ minWidth, maxWidth, width, fullWidth, style });
    const stateClass = getInputStateClass({ disabled, readOnly, isValid });
    const clearButton = ((value === null || value === void 0 ? void 0 : value.length) > 0 && !disabled && !readOnly) ? (_jsx("button", { type: "button", className: "uxpcore_input__clear-btn uxpcore_input__clear-btn--textarea", onClick: (e) => { e.stopPropagation(); onClear ? onClear() : onChange(''); }, tabIndex: -1, children: _jsx(FontAwesomeIconWrapper, { icon: ['fas', 'times'] }) })) : null;
    return _jsxs("div", { className: classNames("uxpcore_input", "uxpcore_input--textarea", className, stateClass, {
            "uxpcore_input--has-content": (value === null || value === void 0 ? void 0 : value.length) > 0,
            "uxpcore_input--full-width": fullWidth
        }), ref: inputContainerRef, style: inputSizeStyles, children: [_jsx("textarea", { ref: inputRef, className: classNames('uxpcore_input__input', 'uxp-form-input'), value: value, onChange: handleChange, onBlur: handleBlur, onFocus: handleFocus, onKeyDown: handleKeyDown, rows: rows, cols: cols, disabled: disabled, readOnly: readOnly, tabIndex: tabIndex || 0, dir: context.direction || 'ltr' }), clearButton] });
});
export default TextArea;
